module.exports = "pegasus/assets/preview-1.png";